<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5 d-flex align-items-center" to="/">
                <img src="img/main/orchardG3.png" alt="logo">
                <a href="index.php" class="navbar-brand pl-3 font-weight-bold" style="font-size:25px;color: #0b545b;">傲卓集團</a>
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/" class="d-flex align-items-center">
                        <img src="img/main/orchardG3.png">
                        <span class="text-dark pl-2 font-weight-bold" style="font-size:18px;">傲卓集團</span>
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
                <router-link slot="title" to="#about" class="nav-link" role="button">
                    <i class="ni ni-ui-04 d-lg-none"></i>
                    <span class="nav-link-inner--text text-dark font-weight-bold">關於我們</span>
                </router-link>
                <router-link to="#product" class="nav-link" role="button">
                    <i class="ni ni-ui-04 d-lg-none"></i>
                    <span class="nav-link-inner--text text-dark font-weight-bold">相關產品</span>
                </router-link>
                <router-link to="#contact" class="nav-link" role="button">
                    <i class="ni ni-ui-04 d-lg-none"></i>
                    <span class="nav-link-inner--text text-dark font-weight-bold">聯絡我們</span>
                </router-link>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton
  }
};
</script>
<style>
</style>
